import {useCompanyTariffGuard} from '../../../modules/company-tariff';
import {FC, useContext, useEffect, useState} from 'react';
import {useRecoilStateLoadable} from 'recoil';

import AddIcon from '@mui/icons-material/Add';
import {Button, Stack} from '@mui/material';
import {ModalNewType} from '../../../components/Dictionaries/DeviceTypes/device-type-code/ModalNewType';
import Fallback from '../../../ui/fallback/Fallback';
import NavCards from '../../../ui/nav-cards/NavCards';
import NotFoundError from '../../../ui/not-found/NotFoundError';

import {deviceTypesDictQuery} from '../../../store/deviceTypes/selectors';

import {green} from '@mui/material/colors';

import {EventBusContext} from '../../../providers/EventBus';

import styles from './DeviceTypes.module.scss';

const DeviceTypesPage: FC = () => {
  const {checkTariff, tariffLoading} = useCompanyTariffGuard();
  const [{state, contents}, setDeviceTypes] = useRecoilStateLoadable(deviceTypesDictQuery);
  const [open, setOpen] = useState(false);
  const {bus} = useContext(EventBusContext);

  const toggleModalToCreate = () => {
    if (!open && !checkTariff()) return;
    setOpen(!open);
  };

  useEffect(() => {
    state === 'hasValue' && setDeviceTypes(contents);

    state === 'hasError' &&
      bus?.emit('error', [
        contents,
        {
          toastId: 'deviceTypes',
        },
      ]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return state === 'loading' ? (
    <Fallback />
  ) : state === 'hasError' ? (
    <NotFoundError />
  ) : (
    <div className={styles.deviceTypes}>
      <Stack direction="row" sx={{justifyContent: 'center', mt: 4}}>
        <Button
          onClick={toggleModalToCreate}
          disabled={tariffLoading}
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          sx={{
            height: '40px',
            fontSize: '0.87rem',
            whiteSpace: 'nowrap',
            letterSpacing: '0',
            backgroundColor: green[500],
            textTransform: 'none',
            '&:hover': {
              backgroundColor: green[600],
            },
          }}
        >
          Добавить тип
        </Button>
      </Stack>
      <div className={styles.navCards}>
        <NavCards
          variant="grid"
          menu={
            contents.content.reduce((acc: any, cur: any) => {
              if (cur.higherCode) return acc;

              return (
                acc.push({
                  link: `/dictionaries/deviceTypes/${cur.code}`,
                  title: cur.name,
                }) && acc
              );
            }, []) as any
          }
        />
      </div>
      {open && <ModalNewType open={open} handleClose={toggleModalToCreate} />}
    </div>
  );
};

export default DeviceTypesPage;
